<template>
    <div v-if="bizAuth.createContractBill.hasRight" class="biz-new-bill-page">
        <new-bill-comp :isEdit="true" :class="{'fixed': listIsFixed}"></new-bill-comp>
    </div>
</template>
<script>
import bizBreadcrumb from '@/components/bussiness/widges/tools/bizBreadcrumb.vue';
import newBillComp from '@/components/bussiness/financialReport/billMgt/newBillComp.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            listIsFixed: false
        }
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        'bizAuth.createContractBill.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        bizBreadcrumb,
        newBillComp
    }
}
</script>
<style lang="scss" scoped>
    .biz-new-bill-page{
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/financialReport/billMgt/editBill.vue